import {useQuery} from "@tanstack/react-query";
import {ApiConfig} from "@/config/api.config";
import {DashboardEventsResponseDto} from '@/features/dashboard/types/dashboard-dto';
import {UrlHelper} from "@/utils/UrlHelper.ts";
import {DateTimeHelper} from "@/utils/dateTimeHelper.ts";
import {useDashboardFilter} from '@/features/dashboard/hooks/useDashboardFilter';
import {useAxiosAuth} from "@/hooks/useAxiosAuth.ts";
import {useCurrencyStore} from "@/store/useCurrencyStore.ts";

export const useDashboardRecentEventsApi = () => {
    const axiosInstance = useAxiosAuth();
    const {filter} = useDashboardFilter();
    const {startDate, endDate, apartmentId} = filter;
    const {currentCurrency} = useCurrencyStore();

    const apartmentIds = apartmentId?.map((apartment) => apartment.id);

    const {
        data: recentEventsData,
        isLoading: isLoadingRecentEventsData,
        isError: isErrorRecentEventsData
    } = useQuery({
        queryKey: [
            ApiConfig.queries.features.dashboard.queryKeys.recentEvents,
            startDate, endDate, apartmentId, currentCurrency
        ],
        queryFn: async () => {
            const url = UrlHelper.buildUrlWithQueryParams(ApiConfig.queries.features.dashboard.endpoints.recentEvents, {
                startDate: DateTimeHelper.getDateOnly(startDate),
                endDate: DateTimeHelper.getDateOnly(endDate),
                apartmentId: apartmentIds
            });
            const response = await axiosInstance.get<DashboardEventsResponseDto>(url);
            return response.data;
        },
    });

    return {
        recentEventsData,
        isLoadingRecentEventsData,
        isErrorRecentEventsData,
    }
};